"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenInputTheme = void 0;
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var LegacyCombobox_1 = __importDefault(require("Common/LegacyCombobox/LegacyCombobox"));
var Types_1 = require("@CommonFrontendBackend/Tokens/Types");
var withTokenSearchContext_1 = __importDefault(require("Project/QwilrEditor/Providers/TokenScope/withTokenSearchContext"));
var mobx_1 = require("mobx");
var PRIMARY_MOUSE_BUTTON = 0;
var TokenInputTheme;
(function (TokenInputTheme) {
    TokenInputTheme["Dark"] = "dark";
    TokenInputTheme["Light"] = "light";
})(TokenInputTheme || (exports.TokenInputTheme = TokenInputTheme = {}));
var TokenInput = (function (_super) {
    __extends(TokenInput, _super);
    function TokenInput(props) {
        var _this = _super.call(this, props) || this;
        _this.isEditing = false;
        _this.autoSelect = true;
        _this.getEntries = function (searchTerm) { return __awaiter(_this, void 0, Promise, function () {
            var _a, type, searchTokens, onTokenMatchedBySearch, tokens, token;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, type = _a.type, searchTokens = _a.searchTokens, onTokenMatchedBySearch = _a.onTokenMatchedBySearch;
                        this.tempTokenLabel = searchTerm;
                        return [4, searchTokens({ dataType: type, searchTerm: searchTerm })];
                    case 1:
                        tokens = _b.sent();
                        token = tokens.find(function (token) {
                            return (token.apiName.toLowerCase() === _this.tempTokenLabel.toLowerCase() ||
                                token.name.toLowerCase() === _this.tempTokenLabel.toLowerCase());
                        });
                        if (token) {
                            onTokenMatchedBySearch(token);
                        }
                        return [2, tokens.map(function (token) { return ({
                                value: token.id,
                                label: token.name,
                                data: token,
                            }); })];
                }
            });
        }); };
        _this.onSelect = function (entry) {
            _this.isEditing = false;
            _this.props.onTokenChange(entry.data);
        };
        _this.cancelEditing = function () {
            var _a = _this.props, token = _a.token, onTokenChange = _a.onTokenChange;
            if (token) {
                _this.isEditing = false;
            }
            else {
                onTokenChange(undefined);
            }
        };
        _this.startEditing = function () {
            _this.isEditing = true;
        };
        _this.onClickTokenContainer = function (event) {
            if (event.button === PRIMARY_MOUSE_BUTTON) {
                _this.startEditing();
            }
        };
        _this.renderComboboxEntry = function (entry) {
            return (react_1.default.createElement(kaleidoscope_1.Token, { type: entry.data.dataType === Types_1.TokenDataType.List ? "list" : "text", theme: _this.mapTokenInputThemeToTokenTheme(_this.props.theme), name: entry.label }));
        };
        var token = props.token, startingSearchTerm = props.startingSearchTerm;
        if (!token) {
            if (startingSearchTerm) {
                _this.autoSelect = false;
                _this.tempTokenLabel = startingSearchTerm;
            }
            _this.startEditing();
        }
        return _this;
    }
    TokenInput.prototype.render = function () {
        var _a;
        var _b = this.props, label = _b.label, placeholder = _b.placeholder, variant = _b.variant, theme = _b.theme, size = _b.size, endElement = _b.endElement, token = _b.token;
        if (this.isEditing) {
            return (react_1.default.createElement(LegacyCombobox_1.default, { className: "token-input__combobox-list", autoSelect: this.autoSelect, autoFocus: !this.autoSelect, placeholder: placeholder, entries: this.getEntries, onSelect: this.onSelect, onCancel: this.cancelEditing, startingSearchTerm: this.tempTokenLabel, label: label, renderEntry: this.renderComboboxEntry, variant: variant, theme: this.mapTokenInputThemeToTextInputTheme(theme), size: size, endElement: endElement }));
        }
        else {
            return (react_1.default.createElement("div", { className: "token-input__pill-holder", onMouseDown: this.props.useOnClickNotOnMouseDown ? undefined : this.onClickTokenContainer, onClick: this.props.useOnClickNotOnMouseDown ? this.onClickTokenContainer : undefined },
                react_1.default.createElement(kaleidoscope_1.Token, { type: (token === null || token === void 0 ? void 0 : token.type) === Types_1.TokenDataType.List ? "list" : "text", theme: this.mapTokenInputThemeToTokenTheme(theme), name: (_a = token === null || token === void 0 ? void 0 : token.label) !== null && _a !== void 0 ? _a : "" })));
        }
    };
    TokenInput.prototype.mapTokenInputThemeToTextInputTheme = function (theme) {
        switch (theme) {
            case TokenInputTheme.Dark:
                return "dark";
            case TokenInputTheme.Light:
                return "light";
        }
    };
    TokenInput.prototype.mapTokenInputThemeToTokenTheme = function (theme) {
        switch (theme) {
            case TokenInputTheme.Dark:
                return kaleidoscope_1.TokenTheme.Dark;
            case TokenInputTheme.Light:
                return kaleidoscope_1.TokenTheme.Light;
        }
    };
    TokenInput.defaultProps = {
        label: "Select a token",
        placeholder: "Type a token name",
        variant: kaleidoscope_1.TextInputVariant.Borderless,
        theme: TokenInputTheme.Dark,
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], TokenInput.prototype, "tempTokenLabel", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], TokenInput.prototype, "isEditing", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TokenInput.prototype, "onSelect", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TokenInput.prototype, "cancelEditing", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TokenInput.prototype, "startEditing", void 0);
    TokenInput = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], TokenInput);
    return TokenInput;
}(react_1.default.Component));
exports.default = (0, withTokenSearchContext_1.default)(TokenInput);
